import { render, staticRenderFns } from "./DeleteAccountView.vue?vue&type=template&id=c552d3c6&scoped=true&"
import script from "./DeleteAccountView.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccountView.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteAccountView.vue?vue&type=style&index=0&id=c552d3c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c552d3c6",
  null
  
)

export default component.exports